
import './style.css'
import logo from '../../../assets/images/logo.jpeg';
import {getRoles, authenticate} from '../../../state/user/actions';
import { Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
     Typography, Select, MenuItem, FormHelperText, Alert } from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { set } from 'lodash';

export const Login = (props) => {
    const [error, setError] = useState({})
    const {roles, user, authencation_error} = useSelector((state) => (state.user || {}))
    const [role, setRole] = useState('')
    const [employeeCode, setEmployeeCode] = useState('')//emp-lov3ubx3
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)

    const dispatch = useDispatch()
    useEffect(()=> {
        dispatch(getRoles())
    },[])
    useEffect(()=> {
        if(roles && roles.length>0)
        setRole(roles[0]._id)
        if(user) {
            props.history.push('/')
        }
    }, [roles, user])

    useEffect(()=>{
        console.log(error)
    }, [error])

    useEffect(()=> {
        setError({})

    }, [employeeCode,password, role])

    useEffect(()=> {
        console.log(authencation_error)
        if(authencation_error) {
            setError({...error, invalid: authencation_error.message})
        }
    }, [authencation_error])

    const handleSubmit = async() => {
        let nowError = {}
        if(!employeeCode) {
            nowError.code = 'Please enter employee code.'
        }
        if(!password) {
            nowError.password = 'Please enter password.'
        }
        
        if(Object.values(nowError).length>0) {
           setError({...nowError})
            return
        }
        dispatch(authenticate({password, uuid: employeeCode, role}))
    }

    return (
        <>
            <div className='login-page'>
                <div className='inner'>
                    <div className='cover'>
                        <Box sx={{ mt: -6 }}>
                            <div className='logo-container'>
                                <img src={logo} className='logo'></img>
                            </div>
                            <Typography variant="heading" gutterBottom sx={{ textAlign: 'center', mt: 4, mb: 4 }}>
                                CRM Portal
                            </Typography>
                            <div className='login-box'>
                                <Box className='heading' sx={{ boxShadow: 1, alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                    <Box sx={{display:'flex', alignItems: 'center'}}>
                                    <Group sx={{ color: '#274073', fontSize: '1.2em' }} />  &nbsp;
                                    <Typography variant='subHead'>
                                        Login
                                    </Typography>
                                    </Box>
                                    <Box sx={{ minWidth: 140, display:'flex' }}>
                                        <Typography variant='p'>{'as'}&nbsp;</Typography>
                                        <FormControl fullWidth size="small" sx={{border:'0px'}}>
                                            {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                                            <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={role}
                                            // label="Age"
                                            onChange={({target})=>{
                                                setRole(target.value)
                                            }}
                                            >
                                                {
                                                    roles && Array.isArray(roles) &&
                                                    roles.map((role,i) => {
                                                        return (<MenuItem key={i} value={role._id}>{role.name}</MenuItem>)
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    
                                </Box>
                                <Box className='input-box' >
                                    {
                                        error.invalid&&
                                        <Alert severity="error" sx={{mb:4}}>{error.invalid}</Alert>

                                    }
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '100%' }}>
                                        <AccountCircleOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                        <TextField fullWidth label="Employee Code" variant="standard" 
                                        onChange={(e)=> setEmployeeCode(e.target.value)}
                                        value={employeeCode}
                                        error={!!error.code}
                                        helperText={error.code || ''}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '100%', mt: 2 }}>
                                        <LockOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                        <FormControl fullWidth sx={{}} variant="standard" 
                                        error={!!error.password}
                                        >
                                            <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                                            <Input
                                                value={password}
                                                onChange={(e)=>setPassword(e.target.value)}
                                                id="standard-adornment-password"
                                                type={showPassword ? 'text':'password'}
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={()=>setShowPassword(!showPassword)}
                                                            onMouseDown={() => { }}
                                                        >
                                                            {true ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                            {
                                                error.password && <FormHelperText>{error.password}</FormHelperText>
                                            }
                                        </FormControl>

                                    </Box>
                                    <Box>
                                        <Button variant="contained" sx={{ mt: 6, float: 'right', mb: 3, pl:4, pr:4 }} onClick={()=> {
                                            setError({})
                                            handleSubmit()
                                            }}>Login</Button>
                                    </Box>

                                </Box>

                            </div>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1, mt: 2 }}>
                                <Typography variant='paraPrimary' style={{cursor: 'pointer'}}>
                                    Forgot Password?
                                </Typography>

                            </Box>

                        </Box>
                    </div>
                </div>
            </div>
        </>
    )
}